import { WarehouseService } from './services/warehouse.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { MenuItems } from './shared/menu-items/menu-items';
import { BreadcrumbsComponent } from './layout/admin/breadcrumbs/breadcrumbs.component';
import { CustomerService } from './services/customer.service';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { UserService } from './services/user.service';
import { AuthenService } from './services/authen.service';
import { SessionTimeoutService } from './services/session-timeout.service';
import { AuthGuard } from './guard/_guards/auth.guard';
import { ClickOutsideModule } from 'ng-click-outside';
import { DatePipe } from '@angular/common';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PermissionService } from './services/permission.service';
import { GoodIssueService } from './services/GoodIssue.service';
import { ModalService } from './services/modal.service';
import { HttpModule } from '@angular/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthInterceptor } from './directive/auth-interceptor';
import { ErrorInterceptor } from './directive/error.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, AdminComponent, AuthComponent, BreadcrumbsComponent],
  imports: [
    BrowserModule,
    ClickOutsideModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    Ng4LoadingSpinnerModule.forRoot(),
    HttpClientModule,
    HttpModule,

    NgbModule,
    OAuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      useDefaultLang: true
    })
  ],
  providers: [
    TranslateService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthGuard,
    MenuItems,
    CustomerService,
    WarehouseService,
    UserService,
    AuthenService,
    SessionTimeoutService,
    PermissionService,
    GoodIssueService,
    ModalService,
    DatePipe,
  ],
  bootstrap: [AppComponent]

})
export class AppModule {}
